export async function getApiErrorMessage(response, fallbackMessage) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const payload = await response.json().catch(() => null);
    return payload?.error || payload?.message || payload?.details || fallbackMessage;
  }

  if (response.status === 413) {
    return 'La imagen es demasiado grande para el servidor.';
  }
  if (response.status === 502 || response.status === 503 || response.status === 504) {
    return 'El servicio de análisis está tardando demasiado. Inténtalo de nuevo en unos segundos.';
  }

  return fallbackMessage;
}

export async function fetchWithTimeout(url, options = {}, timeoutMs = 55000) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('La operación tardó demasiado. Inténtalo de nuevo.');
    }
    throw error;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
